import SwiperCore, { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'
import { Business } from './Business'

import { Container, Businesses, Sector, Button } from './style'

import './slider.css'

SwiperCore.use([Navigation])


export function SectorsAndBusiness({ 
    sectors,
    business, 
    fetchBusinessDatas,
    nextPage,
    fetchMoreBusiness,
    loadingMoreBusiness 
}) {


    
    return(
        <Container>
            <Swiper
                slidesPerView={'auto'}
                spaceBetween={10}
                navigation={true}
                style={{ padding: "1.5rem 0"}}
            >
                {
                    sectors.map(section => (
                        <SwiperSlide key={section.idSector}>
                            <Sector
                                onClick={() => fetchBusinessDatas(section.idSector)}
                                img={section.linkImage}
                            >
                                <p>{section.sector}</p>
                            </Sector>
                        </SwiperSlide>
                    ))
                }
            </Swiper>
            
            
           
                <Businesses>
                    {business.map(business =>(                        
                        <Business 
                            key={business.idBusiness} 
                            business={business}
                        />
                    ))} 
                </Businesses>

                {
                    nextPage !== null && 
                    <Button 
                        onClick={fetchMoreBusiness}
                        loadingMoreBusiness={loadingMoreBusiness}
                    >
                        {
                            loadingMoreBusiness ?
                            'Pesquisando...'
                            :
                            'Ver mais'
                        }
                    </Button>
                }  
    
        </Container>
    )
}

